import { stellateQuery } from '@/helpers/graphql_modules/stellate';
import {
  getDisciplineLives,
  getDisciplineLivesForHome,
  getDisciplineInstance,
} from '@/store/queries/stellate.queries';

import { UndergradLive } from '@/models/undergrad/undergrad-live.model';
import { GetDisciplinesInstancesLivesForHomeResult } from '@/models/undergrad/services/disciplines-reader.model';
import { Lesson } from '@/models/pegasus-epona/lesson.model';

interface PreviewDisciplineInstanceResponse {
  name: string;
  disciplineInstanceId: string;
  description: string;
  slug: string;
  id: string;
  lessons: Lesson[];
  type: string;
}

export class StellateDisciplinesInstancesReaderService {
  public static async getDisciplineInstanceLives(
    disciplineInstanceId: string,
  ): Promise<UndergradLive[]> {
    const {
      data: {
        faculDisciplineInstance: { faculLiveVideo },
      },
    } = await stellateQuery(
      getDisciplineLives,
      {
        disciplineInstanceId,
      },
      {
        'ignore-cache': true,
      },
    );

    return faculLiveVideo;
  }

  public static async getDisciplinesInstancesLivesForHome(
    disciplineInstanceIds: string[],
  ): Promise<GetDisciplinesInstancesLivesForHomeResult[]> {
    const todayDate = new Date();

    const {
      data: { faculDisciplineInstances },
    } = await stellateQuery(
      getDisciplineLivesForHome,
      {
        disciplineInstanceIds,
        todayDate,
      },
      {
        'ignore-cache': true,
      },
    );

    return faculDisciplineInstances;
  }

  public static async getPreviewDisciplineInstance(
    disciplineSlug: string,
  ): Promise<PreviewDisciplineInstanceResponse> {
    const {
      data: { faculDisciplineInstance },
    } = await stellateQuery(
      getDisciplineInstance,
      { disciplineSlug },
      {
        'ignore-cache': true,
      },
    );

    const { faculDiscipline, lessons, id: disciplineInstanceId, slug } = faculDisciplineInstance;

    if (faculDiscipline) {
      return {
        name: faculDiscipline.name,
        disciplineInstanceId,
        description: faculDiscipline.description,
        slug,
        id: faculDiscipline.id,
        lessons,
        type: 'default',
      };
    }

    return {
      name: faculDisciplineInstance.name,
      disciplineInstanceId,
      description: faculDisciplineInstance.description,
      slug,
      id: faculDisciplineInstance.id,
      lessons,
      type: 'default',
    };
  }
}
